export default {
    END_POINT: process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://drsm.ma/api",
}
